<div class="box" [ngClass]="chooseType">
	<i class="box__icon"></i>
	<p class="box__text">
		<ng-content></ng-content>
	</p>
</div>
